import { useId } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

import { useI18n } from '@/shared/contexts/I18nProvider';

import { complianceItems } from '../HomeData';

export const Compliance = () => {
  const { content } = useI18n();
  const copy = content.home.compliance;
  const headingId = useId();
  const noteId = useId();
  const shouldReduceMotion = useReducedMotion();

  return (
    <section
      id="compliance"
      aria-labelledby={headingId}
      className="scroll-mt-24 bg-background-primary py-12 sm:py-16"
    >
      <motion.div
        initial={shouldReduceMotion ? false : { opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: shouldReduceMotion ? 0 : 0.5, ease: 'easeOut' }}
        className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
      >
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between lg:gap-12">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-text-secondary">
              {copy.eyebrow}
            </p>
            <h2
              id={headingId}
              className="mt-3 text-3xl font-light leading-tight tracking-tight text-text-primary sm:text-4xl"
            >
              {copy.title}
            </h2>
          </div>
          <p className="max-w-md text-base leading-7 text-text-secondary">
            {copy.description}
          </p>
        </div>

        <ul
          aria-label={copy.listLabel}
          aria-describedby={noteId}
          className="mt-8 grid grid-cols-2 gap-y-6 sm:mt-10 sm:grid-cols-3 lg:grid-cols-5"
        >
          {complianceItems.map(({ id, name, icon: Icon }) => (
            <li
              key={id}
              className="group relative flex min-w-0 flex-col items-center px-3 py-1 text-center text-text-secondary transition-colors duration-200 before:absolute before:inset-y-2 before:left-0 before:w-px before:bg-border-primary before:content-[''] hover:text-text-primary motion-reduce:transition-none [&:nth-child(2n+1)]:before:hidden sm:[&:nth-child(2n+1)]:before:block sm:[&:nth-child(3n+1)]:before:hidden lg:[&:nth-child(3n+1)]:before:block lg:[&:nth-child(5n+1)]:before:hidden"
            >
              <Icon
                aria-hidden="true"
                className="mb-3 h-7 w-7 text-text-tertiary transition-colors duration-200 group-hover:text-text-secondary motion-reduce:transition-none"
                strokeWidth={1.5}
              />
              <span className="font-mono text-sm font-medium tracking-wide">
                {name}
              </span>
              <span className="mt-1 text-xs leading-5">{copy.items[id]}</span>
            </li>
          ))}
        </ul>

        <p
          id={noteId}
          className="mt-7 text-center text-xs leading-5 text-text-secondary"
        >
          {copy.note}
        </p>
      </motion.div>
    </section>
  );
};
